module.exports = __webpack_public_path__ + "static/media/sylvia.37383dcd.jpg";